
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsf19160d9fc12fc52f4bb05efe2dd2a69en from './en.yaml'
            i18n.addResourceBundle('en', 'f19160d9fc12fc52f4bb05efe2dd2a69', flattenObject(nsf19160d9fc12fc52f4bb05efe2dd2a69en), true, true);
        
        export default 'f19160d9fc12fc52f4bb05efe2dd2a69';
    